module.exports = __webpack_public_path__ + "img/Veritas_island.880e19c9.png";